import BaseStore from "@/Services/BaseService";

export const getAllPersonnelRoutes = async () => {
    try {
        const response = await BaseStore.get('/personnel-routes');

        if (!response) {
            console.log('getAllPersonnelRoutes response', response)
        }

        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const updateRoute = async (routeObj) => {

    try {
        const response = await BaseStore.put(`/routes/${routeObj.RouteId}`,{
             ...routeObj
        });
        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};


export const updatePersonnelRoutes = async (routeObj) => {

    try {
        const response = await BaseStore.put(`/personnel-routes/${routeObj.Route}`,{
             ...routeObj
        });
        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const addRoute = async (routeObj) => {
    try {
        const response = await BaseStore.post(`/routes`,{
             ...routeObj
        });
        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
}

export const addPersonnelRoutes = async (routeObj) => {
    try {
        const response = await BaseStore.post(`/personnel-routes`,{
             ...routeObj
        });
        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
}

export const deleteRoute = async (routeObj) => {

    try {
        const response = await BaseStore.delete(`/routes/${routeObj.RouteId}`);
        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const deletePersonnelRoutes = async (routeObj) => {

    try {
        const response = await BaseStore.delete(`/personnel-routes/${routeObj.Route}`);
        return response?.data;
    } catch (error) {
        return Promise.reject(error);
    }
};